import { Component, OnInit } from '@angular/core';
import { RolesService } from '../../services/roles-service';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { AddRoleComponent } from '../add-role/add-role.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-get-roles-component',
  templateUrl: './get-roles-component.component.html',
  styleUrls: ['./get-roles-component.component.scss']
})
export class GetRolesComponentComponent extends BaseComponent implements OnInit {

  form:FormGroup
  constructor(
    public service: RolesService,
    route: Router,
    private fb:FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private paging: PagingService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.initForm();
    this.loadEntities();
  }
initForm(){
  this.form = this.fb.group({
    name: ['']
  });
}


clearFilter(){
  this.form.controls['name'].setValue('');
  this.loadEntitiesWithFilter('')
}

handleSearch(){

  if(!this.form.value.name){
    this.toast.danger('برجاءاختيار الصلاحية لاتمام عملية البحث', 'رساله تحذيرية');
    return
  }

    if(this.form.value.name){
    const name = this.form.value.name.trim();
    this.form.controls['name'].setValue(name);
    this.loadEntitiesWithFilter(`name:${name}`)

  }



}


  addNew() {
    this.diag
      .open(AddRoleComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }


  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddRoleComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

}
